// extracted by mini-css-extract-plugin
export default {"root":"DoughnutChartIssues_root__ti+yy","dashBoardWrapper":"DoughnutChartIssues_dashBoardWrapper__cDPrr"};